// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__HlUd8","item":"Project_item__9W9Av"};